import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { cronometro } from '../services/functions'
import { listenerQueues } from '../actions/QueuesActions';

class BoxQueues extends Component {
    constructor(props) {
        super(props);
        this.state = {
            waiting: [],
            intevalID: 0
        };
    }

    async componentDidMount() {
        let { queuesAvailable } = this.props.auth;
        let queuesListener = await _.map(queuesAvailable, queue => queue.extension)
        await this.props.listenerQueues(this.props.auth, queuesListener);
        let intevalID = setInterval(this.passouSegundo, 300);
        this.setState({ intevalID }); 
    }

    passouSegundo = () => {
        let newWaiting = this.state.waiting.map( wait => {
            let time = 0;
            if(wait.timestamp){
                time = cronometro(wait.timestamp, new Date().getTime());
            }
            return { ...wait, time}
        })
        
        this.props.waitingCount(newWaiting.length);
        this.setState({ waiting: newWaiting })
    }

    _update = ({waiting, queuesListener}) => {
        const filter = _.filter(waiting, val => queuesListener.indexOf(parseInt(val.queue)) >= 0 );
        const waitingOrderby = _.orderBy(filter, 'time', 'desc')

        this.setState({ waiting: waitingOrderby })
    }

    componentWillReceiveProps(nextProps) {
        this._update(nextProps);
    }

    componentWillUnmount() {
        clearInterval(this.state.intevalID);
    }

    render() { 
        const tblQueue = this.state.waiting.map( row => { 

            let linkedid = row?.linkedid?.replace(/_/gi, ".");
            return (
                <tr key={row.linkedid} title={`Num: ${row.number} | Linkedid: ${linkedid}`}>
                    <td>{row.numbername}</td>
                    <td>{row.queue}</td>
                    <td>{row.time}</td>
                </tr>
            )
        })

        return (
            <div className="box box-warning" style={{ minHeight: '302px' } }>
                <div className="box-header with-border">
                    <h3 className="box-title">Aguardando atendimento</h3>
                </div>
                
                <div className="box-body table-responsive no-padding">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Numero</th>
                                <th>Fila</th>
                                <th>Tempo</th>
                            </tr>
                        </thead>
                        <tbody>
                            { tblQueue }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {

    const waiting = _.map(state.QueuesReducer.waiting, (val, number) => {
        let time = cronometro(val.timestamp, new Date().getTime())

        return {...val, time};
    });

    return ({
        auth: state.AutenticacaoReducer,
        waiting,
    })
}
  
export default connect(mapStateToProps, { listenerQueues })(BoxQueues);